module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-pas"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.value
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.user_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "user_name", $$v)
      },
      expression: "value.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.passwors),
      callback: function($$v) {
        _vm.$set(_vm.value, "passwors", $$v)
      },
      expression: "value.passwors"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "两次输入新密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.newPasswors),
      callback: function($$v) {
        _vm.$set(_vm.value, "newPasswors", $$v)
      },
      expression: "value.newPasswors"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确定修改")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1017dda4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalData/password/index.vue
// module id = 257
// module chunks = 18